import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

// Pre-expiry inactivity warning: shown ~2 minutes before the mandatory
// 30-minute idle logout. Any real interaction (or Stay Signed In) clears it.
export function IdleWarning() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = () => setVisible(true);
    const hide = () => setVisible(false);
    window.addEventListener("tfs-idle-warning", show);
    window.addEventListener("tfs-hide-idle-warning", hide);
    return () => {
      window.removeEventListener("tfs-idle-warning", show);
      window.removeEventListener("tfs-hide-idle-warning", hide);
    };
  }, []);
  if (!visible) return null;
  return (
    <div className="fixed bottom-6 right-6 z-[100] w-80 rounded-sm border-2 border-[#B45309]/60 bg-white p-4 shadow-xl" data-testid="idle-warning">
      <p className="text-sm font-bold text-[#09090B]">Still there?</p>
      <p className="mt-1 text-sm text-[#52525B]">You&apos;ll be signed out in about 2 minutes due to inactivity.</p>
      <Button className="mt-3 w-full rounded-sm bg-[#569A1F] font-semibold text-white hover:bg-[#457d18]"
        onClick={() => { api.post("/presence/activity").catch(() => {}); setVisible(false); }}
        data-testid="stay-signed-in-btn">
        Stay Signed In
      </Button>
    </div>
  );
}
